module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-5-5d075511b5fff4cc4aa2433ece1f426d.svg";